// Copyright 2019 Drivetrain Hub LLC
// GraphQL request helpers for session data.

const Organization = `
  Id
  name
  active
  gearsTrialUntil
  users {
    Id
    email
    firstName
    lastName
  }`;

const User = `
  Id
  email
  firstName
  lastName
  membership
  active
  recentlyOpenedGears
  organization {
    ${Organization}
  }`;

export default {
  User: User,
}
